import { jwtDecode } from 'jwt-decode';

// 🔥 tipagem do seu token
export interface JwtPayload {
  idempresa: string;
  iduser: string;
  tipoimp: number;
  refs: boolean;
  img: string;
  decimais: number;
  margem: number;
  est: boolean;
}

// 🔥 cache tipado
let authCache: JwtPayload | null = null;

// 🔥 carrega e salva no cache
export const loadAuth = (): JwtPayload | null => {
  const token = localStorage.getItem('APP_ACCESS_TOKEN');
  
  if (!token) {
    authCache = null;
    return null;
  }

  try {
    authCache = jwtDecode<JwtPayload>(token);
    return authCache;
  } catch {
    authCache = null;
    return null;
  }
};

// 🔥 pega do cache (rápido)
export const getAuth = (): JwtPayload | null => {
  return authCache;
};